import { makeStyles } from '@material-ui/core';

import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';

import { ExpressionDiff } from './ExpressionDiff';
import { formatAllocation, hasChanged, isEmptyExpression } from './formatting';
import { SegmentData } from './types';
import { useResolveCriterionDisplayNames } from './useResolveCriterionDisplayNames';

const useStyles = makeStyles({
  criteriaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--encore-spacing-tighter-4)',
    paddingTop: 'var(--encore-spacing-tighter-4)',
  },
});

export const AudienceSegmentRender = ({ change }: ActivityChangeOptions) => {
  const classes = useStyles();
  const oldValue = change.oldValue as SegmentData | null;
  const newValue = change.newValue as SegmentData | null;

  const oldAllocation = oldValue?.allocation?.proportion?.value;
  const newAllocation = newValue?.allocation?.proportion?.value;

  const oldTargeting = oldValue?.targeting;
  const newTargeting = newValue?.targeting;
  const targetingChanged = hasChanged(oldTargeting, newTargeting);
  const inclusionCriteriaChanged =
    targetingChanged &&
    (!isEmptyExpression(oldTargeting?.expression) ||
      !isEmptyExpression(newTargeting?.expression));

  const oldCriteria = useResolveCriterionDisplayNames(
    oldTargeting?.criteria ?? {},
  );
  const newCriteria = useResolveCriterionDisplayNames(
    newTargeting?.criteria ?? {},
  );

  return (
    <>
      {oldAllocation !== newAllocation && (
        <ActivityItem.Section label="Updated allocation">
          <ActivityTagItem
            oldValue={formatAllocation(oldAllocation)}
            newValue={formatAllocation(newAllocation)}
          />
        </ActivityItem.Section>
      )}
      {inclusionCriteriaChanged && (
        <ActivityItem.Section label="Updated inclusion criteria">
          <div className={classes.criteriaContainer}>
            <ExpressionDiff
              oldExpr={oldTargeting?.expression}
              newExpr={newTargeting?.expression}
              oldCriteria={oldCriteria}
              newCriteria={newCriteria}
            />
          </div>
        </ActivityItem.Section>
      )}
    </>
  );
};
